import IconCheck from "../../assets/svgs/check.svg";
import "./log.css";
import formatLogToHtml from "../../utils/formatLogToHtml";
import { useState } from "react";
import ModalLog from "../fluxo-engenheiro/modalLog/modalLog";
interface LogItemProps {
  pergunta?: number;
  textPlus?: string;
  label?: string;
  message?: string;
  onClick?: () => void;
  modalTitleLog?: string;
  modalSubtitleLog?: string;
  modalTextLog?: string;
}

const Log = ({
  pergunta,
  label,
  message,
  onClick,
  textPlus,
  modalTitleLog,
  modalSubtitleLog,
  modalTextLog,
}: LogItemProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const maxChars = 120;

  const stripHtml = (html: string) => {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  const truncateText = (text: string) => {
    if (!text) return "";
    return text.length > maxChars ? text.slice(0, maxChars) + "..." : text;
  };

  const labelHtml = formatLogToHtml(label);
  const messageHtml = formatLogToHtml(message);

  const labelText = stripHtml(labelHtml);
  const messageText = stripHtml(messageHtml);

  const isLongText =
    labelText.length > maxChars || messageText.length > maxChars;

  return (
    <>
      <div className="responseDiv">
        <div className="titleLogQuestion">
          <button
            type="button"
            onClick={onClick}
            aria-label="Icone check"
            className="iconCheckButton"
          >
            <img src={IconCheck} className="iconCheck" alt="Check icon"/>
          </button>
          <span className="numberQuestion">{"Pergunta " + pergunta}</span>
        </div>
        <div className="QuestionContainer">
          <span
            className="logQuestionLabel"
            dangerouslySetInnerHTML={{ __html: truncateText(labelText) }}
          />

          <div className="containerPlus">
            {isLongText && textPlus && (
              <button
                type="button"
                className="textPlus"
                onClick={() => setIsModalOpen(true)}
              >
                {textPlus}
              </button>
            )}
          </div>
        </div>
        <div className="plus">
          <span className="logQuestionMessage">
            <strong style={{ fontSize: 16, fontWeight: 700 }}>
              Resposta:{" "}
            </strong>
            {truncateText(messageText || "")}
          </span>
        </div>
      </div>

      {isModalOpen && (
        <ModalLog
          className="modalContent"
          titleModalLog={modalTitleLog || ""}
          subTitleModalLog={modalSubtitleLog || ""}
          textModalLog={modalTextLog || ""}
          onClose={() => setIsModalOpen(false)}
          imgIcon={IconCheck}
        />
      )}
    </>
  );
};
export default Log;
